// Foster Care Awareness 365 — Kid profiles data
// All assets served locally from /assets/* (uploaded by the FC365 team)
const A = "/assets";

export const KIDS = [
  {
    slug: "malik",
    name: "Malik",
    age: 9,
    tagline: "Philly's Pretzel Champion with a Heart for Hoops",
    short: "Energetic, empathetic, and bonded to Philly. Malik thrives with clear boundaries and encouragement.",
    summary:
      "Malik is a Philadelphia boy who knows every Eagles player and every local pretzel shop. He's bright, empathetic, and needs a male role model who can channel his energy into sport, school, and structure.",
    hero: `${A}/chatgpt-image-apr-24-2025-03_12_10-pm.png`,
    profile_card: "/assets/conociendo-a-malik-en-la-ciudad.png",
    experience_card: "/assets/chatgpt-image-apr-24-2025-03_12_10-pm.png",
    youtube: "https://www.youtube.com/watch?v=QJQUKiu637k",
    youtube_id: "QJQUKiu637k",
    bonus_video_id: "xPYwDlavZus",
    bonus_video_title: "Philly Pretzel Victory | Malik's Moment of Generosity",
    background: [
      "Removed due to parental neglect tied to substance use and housing instability",
      "Has been in 3 placements within 18 months",
      "No contact with birth father; mother in outpatient recovery",
      "Currently in a pre-adoptive foster home",
    ],
    personality: [
      "Energetic and loves to stay active",
      "Sometimes impulsive but not defiant",
      "Builds strong bonds with male caregivers",
      "Very empathetic toward animals and younger children",
      "Needs clear boundaries and praise-based feedback",
    ],
    likes: [
      "Philadelphia Eagles (knows all the players)",
      "Basketball at the local rec center",
      "Math games and puzzles",
      "Music — especially rap and old-school hip-hop",
      "Favorite food: soft pretzels and cheesesteaks",
    ],
    dislikes: [
      "Being singled out in class",
      "Sudden changes in routine",
      "Feeling misunderstood or \"labeled\"",
      "Loud arguments (can trigger shutdown behavior)",
    ],
    needs: [
      "Foster family familiar with urban youth and trauma care",
      "Access to after-school mentorship programs (e.g., Big Brothers Big Sisters of Philly)",
      "Academic IEP support through the Philadelphia School District",
      "Trauma-informed mental health services",
      "Cultural representation and male role modeling",
    ],
  },
  {
    slug: "ariana",
    name: "Ariana",
    age: 13,
    tagline: "A Spark of Color in the Foster System",
    short: "Strong-willed, artistic, protective of her siblings. Needs a home where creativity is celebrated.",
    summary:
      "Ariana is 13 and electric. She paints how she feels, speaks her mind, and isn't afraid to stand out. She's spent years in and out of placements, but what she really wants is one place to call home — where art is encouraged, emotions are heard, and love doesn't come with conditions.",
    hero: `${A}/chatgpt-image-apr-24-2025-03_12_33-pm.png`,
    profile_card: "/assets/chatgpt-image-apr-24-2025-03_12_33-pm.png",
    experience_card: "/assets/chatgpt-image-apr-24-2025-03_12_33-pm.png",
    youtube: "https://www.youtube.com/watch?v=ZyOYx1inAvM",
    youtube_id: "ZyOYx1inAvM",
    bonus_video_id: "Q-QlB813hm0",
    bonus_video_title: "Ariana's Song | Her Story. Her Strength.",
    background: [
      "Entered care at age 11 due to physical abuse and truancy concerns",
      "Two younger siblings in separate placements",
      "History of parent incarceration and housing instability",
      "Currently placed in a therapeutic foster home",
    ],
    personality: [
      "Strong-willed and fiercely independent",
      "Very protective of her siblings",
      "Expressive and creative — uses journaling and music as outlets",
      "Trust issues with adults, but very loyal once trust is built",
      "Can be defiant when feeling misunderstood, but craves connection",
    ],
    likes: [
      "Drawing — especially fashion and anime-style art",
      "Listening to music (pop and reggaeton)",
      "Excels in creative writing",
      "Dreams of becoming a designer or social worker",
      "Loves animals — volunteers at a local shelter",
    ],
    dislikes: [
      "Being talked down to or ignored",
      "Authority figures who are overly strict or dismissive",
      "School environments with bullying or lack of cultural representation",
      "Being separated from siblings",
    ],
    needs: [
      "Foster placement that values cultural identity and personal expression",
      "Trauma-informed therapy with a focus on empowerment",
      "Opportunities to build leadership and artistic skills",
      "Advocacy for sibling contact or potential reunification",
      "Female mentor or role model from a similar background",
    ],
  },
  {
    slug: "jayden",
    name: "Jayden",
    age: 16,
    tagline: "A Loyal Big Brother with Dreams on the Court",
    short: "Athletic, loyal, fiercely protective of his siblings. Dreams of pro ball and family reunion.",
    summary:
      "Jayden's the kind of teen who would give you his last hoodie if you were cold. He's 16, quick on his feet, and even quicker to stand up for someone he loves. A natural athlete and big brother at heart, Jayden has been in care since age 11. His dream? To play ball — but more than that, to stay close to the siblings he's been separated from.",
    hero: `${A}/chatgpt-image-apr-24-2025-03_30_11-pm.png`,
    profile_card: `${A}/chatgpt-image-apr-24-2025-03_30_11-pm.png`,
    experience_card: `${A}/meet-jayden_-eagles-fan-extraordinaire.png`,
    youtube: "https://www.youtube.com/watch?v=Azck2dlPzAk",
    youtube_id: "Azck2dlPzAk",
    background: [
      "Removed from home due to chronic neglect and exposure to domestic violence",
      "Birth mother struggling with substance abuse; father absent",
      "Multiple short-term placements, currently in a kinship care setting (with an aunt)",
    ],
    personality: [
      "Observant, quiet around new adults but opens up over time",
      "Protective of younger children",
      "Emotionally resilient but struggles with trust",
      "Likes structured environments and predictability",
      "Sometimes anxious when routines change abruptly",
    ],
    likes: [
      "Building things with Legos",
      "Big fan of superheroes, especially Black Panther",
      "Basketball and riding his bike",
      "Favorite subject: Math",
      "Loves dogs and wants to be a veterinarian one day",
    ],
    dislikes: [
      "Loud yelling or raised voices (triggers anxiety)",
      "Group settings with lots of unfamiliar people",
      "Being left out or overlooked",
      "Moving between schools",
    ],
    needs: [
      "Stable, trauma-informed foster home with consistency",
      "Male role models or mentors",
      "Academic support, especially in literacy",
      "Therapy for trauma-related anxiety",
      "Activities that build confidence and social bonds (e.g., sports, clubs)",
    ],
  },
  {
    slug: "sophia",
    name: "Sophia",
    age: 14,
    tagline: "A Gentle Soul with a Bright Future",
    short: "Thoughtful, resilient, dreams of becoming a nurse. Needs stability and sibling connection.",
    summary:
      "Sophia is 14, quiet but strong, and filled with thoughtful wisdom beyond her years. She finds peace in the pages of historical fiction and strength on hiking trails in Somerset County, PA. Her biggest dream? To become a nurse — someone who heals, because she knows what it means to hurt.",
    hero: `${A}/chatgpt-image-apr-24-2025-04_50_07-pm.png`,
    profile_card: "/assets/chatgpt-image-apr-24-2025-04_50_07-pm.png",
    experience_card: "/assets/chatgpt-image-apr-24-2025-04_50_07-pm.png",
    youtube: "https://www.youtube.com/watch?v=GOwMJ2mEKpk",
    youtube_id: "GOwMJ2mEKpk",
    background: [
      "Entered foster care at 12 due to family domestic violence and parental opioid use",
      "Lived in kinship care briefly, now in traditional foster home",
      "Separated from younger brother (placed elsewhere)",
      "Mother in recovery; father incarcerated",
    ],
    personality: [
      "Thoughtful, observant, and introverted",
      "Very nurturing — often helps with younger foster children",
      "High emotional intelligence for her age",
      "Needs time to build trust, but thrives in stable environments",
      "Very sensitive to conflict but doesn't show it outwardly",
    ],
    likes: [
      "Writing poetry and journaling",
      "Country music and acoustic guitar",
      "Reading (especially historical fiction and romance)",
      "Being outdoors — hiking, camping, and animals",
      "Interested in becoming a nurse someday",
    ],
    dislikes: [
      "Being the center of attention",
      "Group therapy (prefers one-on-one)",
      "Harsh discipline styles",
      "Being far from her brother",
    ],
    needs: [
      "Foster home in her school district to preserve stability",
      "Support for sibling visitation (through PA's SWAN program)",
      "Individual counseling focused on trauma and grief",
      "Engagement in local extracurriculars (4H, church youth group, creative writing clubs)",
      "Long-term placement with high structure and emotional support",
    ],
  },
];

// Banner combining all 4 kids — using "meet-the-kids-at-sunset" since the strict 4-kid-banner isn't in the zip
export const FOUR_KID_BANNER = `${A}/meet-the-foster-kids.png`;

// New cinematic moments from the asset pack
export const KIDS_AT_SUNSET = `${A}/meet-the-kids-at-sunset.png`;
export const FOSTER_CHAMPIONS = `${A}/foster-care-champions-in-the-sunset.png`;
export const FOSTER_STORIES_SUNSET = `${A}/foster-stories-under-a-golden-sunset.png`;
export const CHILDREN_UNITED_HOPE = `${A}/children-united-in-hope.png`;
export const KIDS_PHILLY = `${A}/kids-of-fostercareawareness365-in-philadelphia.png`;
export const SMILES_STYLE = `${A}/smiles-and-style-together.png`;

export const STATS_CARDS = [
  { url: `${A}/500-k-stat-web-slice-copy.jpg`, alt: "500,000 kids need your help" },
  { url: `${A}/foster-stat-3-card-copy.jpg`, alt: "Foster care statistic" },
  { url: `${A}/fca365-card-1-copy.png`, alt: "Child Trafficking" },
  { url: `${A}/fca365-card-7-copy.png`, alt: "Support for Adoptive Families" },
  { url: `${A}/fca365-card-5-copy.png`, alt: "The Complexities of the Foster System" },
  { url: `${A}/fca365-card-6-copy.png`, alt: "Foster care awareness" },
  { url: `${A}/fca365-card-2-copy.jpg`, alt: "Foster care awareness" },
  { url: `${A}/fca365-card-4-copy.png`, alt: "Foster care awareness" },
  { url: `${A}/foster-stat-2-card-copy.jpg`, alt: "Foster care statistic" },
  { url: `${A}/foster-stat-4-card-copy.jpg`, alt: "Foster care statistic" },
  { url: `${A}/foster-stat-5-card-copy.jpg`, alt: "Foster care statistic" },
  { url: `${A}/foster-stat-6-card-copy.jpg`, alt: "Foster care statistic" },
];

export const WELCOME_IMG = `${A}/chatgpt-image-apr-24-2025-03_06_19-pm.png`;
export const HOPE_IMG = `${A}/chatgpt-image-apr-24-2025-04_50_03-pm.png`;
export const FCA_LOGO = `${A}/fca-logo-v2-new-copy-2.png`;
export const CHALLENGE_BANNER = `${A}/365-challenge-day-2-announcement-copy.jpg`;
export const CHALLENGE_DAY1 = `${A}/365-challenge-day-1-announcement-copy.jpg`;
export const CALENDAR_IMG = "/assets/365-challenge-day-1-announcement-copy.jpg";
export const ACTION_GUIDE_IMG = "/assets/365-challenge-day-2-announcement-copy.jpg";

// Tim Kelly portraits (from asset pack)
export const TIM_PORTRAIT_1 = `${A}/apr-24-2025-03_32_42-pm.png`;
export const TIM_PORTRAIT_2 = `${A}/apr-24-2025-03_32_53-pm.png`;

export const HARD_STATS = [
  { num: "424,000+", label: "Children currently in U.S. foster care" },
  { num: "Every 2 min", label: "A child enters the foster care system" },
  { num: "60%", label: "Of child sex trafficking victims have foster histories" },
  { num: "20,000+", label: "Youth age out each year without a family" },
  { num: "2×", label: "More likely to suffer from PTSD than war veterans" },
  { num: "~50%", label: "Foster youth become homeless within 18 months of aging out" },
];

export const GIVING_CAMPAIGNS = [
  { emoji: "🧡", title: "365 Challenge: Because Kids Can't Wait", goal: "365 donations in 31 days to change 100 lives in 365 days", desc: "Join our flagship campaign. Your daily or monthly gift brings stability, healing, and opportunities to children waiting for families." },
  { emoji: "👫", title: "Sponsor a Sibling Visit", goal: "$50", desc: "Reconnects brothers and sisters separated in foster care. No child should lose their sibling too." },
  { emoji: "🎒", title: "Backpacks of Belonging", goal: "$35", desc: "A welcome backpack filled with essentials for children entering care. Simple things that restore dignity." },
  { emoji: "🎂", title: "Birthday Wishes Campaign", goal: "$75", desc: "Ensures every foster child feels seen and celebrated. Cake, candles, and joy on their special day." },
  { emoji: "✨", title: "Holiday Hope Drive", goal: "$100", desc: "Delivers holiday magic — gifts, meals, and moments of joy for children spending the holidays in unfamiliar places." },
  { emoji: "🎓", title: "Future Forward Scholarships", goal: "$250", desc: "Launches a teen aging out of care into a brighter future — laptops, college books, or trade program tools." },
];
